module.exports = __webpack_public_path__ + "img/logo-green-dark.3bb61fd.svg";